module.exports = __webpack_public_path__ + "static/ETE_PRODUCTS_VIDEO-1c550193b8c80fb9a727cc98180e0f56.png";